import {__} from "@wordpress/i18n";

export const save = ( {attributes, className} ) => {
    const {color} = attributes;

    return (
        <div>
            <div style={{padding: "20px", color: color}}>
                {__('Title property', 'realpress')}
            </div>
        </div>
    );
}
